module.exports = __webpack_public_path__ + "cash_and_coins.f90a8c06d54fc4a35db3db8abe7ba111.svg";